import { useSelector, type SelectorReturnFn } from 'core/use-cases/utilities';

import type { Combo } from 'core/domains';

export function useComboSelector(): SelectorReturnFn<Combo['data']> {
  const { data, status, updatedAt = 0 } = useSelector((state) => state.combo);

  return {
    data,
    status,
    updatedAt,
  };
}
